module.exports = __webpack_public_path__ + "static/media/picture_analyze_demo.b6cf1e54.png";